import React from "react";

import { Box, LinearProgress, Typography } from "@mui/material";
import type { SummaryCardData } from "store/types";

interface Props {
  data?: SummaryCardData;
  loading?: boolean;
}

export const SummaryCard: React.FC<Props> = ({ data, loading }) => {
  if (loading || !data) {
    return (
      <Box sx={{ p: "16px 8px 8px" }}>
        <LinearProgress sx={{ mb: "4px" }} />
      </Box>
    );
  }

  const items = [
    { label: "Total", value: data.total },
    { label: "Average", value: data.average },
    { label: "Min", value: data.min },
    { label: "Max", value: data.max }
  ].filter((item) => item.value !== undefined && item.value !== null);

  if (items.length === 0) {
    return (
      <Box sx={{ p: "20px 24px" }}>
        {loading && <LinearProgress sx={{ mb: "4px" }} />}
        <Typography sx={{ fontSize: 12, color: "#9CA3AF" }}>No summary data available</Typography>
      </Box>
    );
  }

  const title = data.measureName || data.parameter || data.title || "Summary";

  return (
    <Box sx={{ p: "20px 24px" }}>
      {loading && <LinearProgress sx={{ mb: "4px" }} />}
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "#6B7280",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          mb: "12px"
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "14px 20px",
          justifyContent: "space-between"
        }}
      >
        {items.map((item) => (
          <Box key={item.label} sx={{ borderLeft: "3px solid #1A3C34", pl: "10px" }}>
            <Typography
              sx={{
                fontSize: 10,
                fontWeight: 600,
                color: "#9CA3AF",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                mb: "3px"
              }}
            >
              {item.label}
            </Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827" }}>{item.value}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
